<template>
<div class="" style="clear: both; width: 100%;min-height: 81px;">
    <div class="w3-hide-small">
		<Desktop  />
	</div>
	<div class="w3-hide-medium w3-hide-large">
		<Mobile  />
	</div>
</div>
</template>

<script>
	import Desktop from './navDesktop';
    import Mobile from './navMobile';
	import SpaConstants from '../../../constants';
    export default {
        mounted() {
			
        },
		
		props: {

		},

		data () {
			return {

			}
		},
		created () {
		
		},

		computed: {
			isLogged() { 
				return this.$store.state.options.islogged;
			},
			site_name(){
				return SpaConstants.site_name;
			},
			html_logo(){
				return SpaConstants.html_logo;
			},
			menu() {
				return this.$store.state.navigation.menu;
			},
			main_site() {
				return window.main_site_url;
			},
			base_site() {
				return window.base_url;
			}
		},

		watch: {
			
		},
		methods: {
			
		},
		components: {
			Desktop, Mobile
		}
    }
</script>

<style>

</style>

